export interface OrderType {
  orderTypeCode: string;
  orderTypeId?: string;
  orderTypeDesc?: string;
  commercialChannelCode?: string;
  commercialChannelDesc?: string;
}
